import React from "react";
import { NoDataIco } from "../../assets/customIcons";
import styles from "./NotFound.module.scss";

export const NotFound = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <NoDataIco />
        <h1>Данные не найдены!</h1>
      </div>
    </div>
  );
};
